//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiMapMarkerOutline } from '@mdi/js'

export default {
  setup() {
    return {
      icons: {
        mdiMapMarkerOutline,
      },
    }
  },
}
